import React, {useState, useEffect} from 'react';
import {categoryOptions} from './data';
import * as S from './style';
import {
	Table,
	Space,
	Button as AntdButton,
	Modal,
	Radio,
	Input,
	Row,
	Col,
} from 'antd';
import BoardForm from '../BoardForm';
import {deleteBoard, getListBoard} from '../../../api/board';
import BoardUpdateForm from '../BoardUpdateForm';
import dayjs from 'dayjs';

const {Column} = Table;

const AdminBoard = () => {
	const [search, setSearch] = useState('');
	const [category, setCategory] = useState('공지');
	const [staycategory, setStayCategory] = useState('공지');
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(1);
	const [modal, setModal] = useState({update: false, create: false});
	const [post, setPost] = useState([]);
	const [id, setId] = useState(0);
	const [toggle, setToggle] = useState(false);
	const [ordering, setOrdering] = useState('');

	useEffect(() => {
		(async () => {
			if (category != staycategory) {
				var res = await getListBoard({category, page: 1, ordering, search});
			} else {
				res = await getListBoard({category, page, ordering, search});
			};
			let data = res.data.results.map((post, idx) => {
				return {...post, no: res.data.count - (page - 1) * 10 - idx};
			});
			setPost(data);
			setTotal(res.data.count);
		})();
	}, [category, page, toggle, ordering, search]);

	const setSorter = (sorts) => {
		if (!Array.isArray(sorts)) {
			sorts = [sorts];
		}

		let sortList = sorts.map((item) => {
			if (item.order) {
				return `${item.order === 'ascend' ? '' : '-'}${item.field}`;
			}
		});
		if (sortList) {
			setOrdering(sortList.join(','));
		}
	};
	const goToBoard = () => {
		const href_mapper = {
			공지: '/ground/notify',
			자유: '/ground/free',
			// 홍보: '/ground/promotion',
			기록: '/record/boards',
			// 환불: '/ground/refund',
			사진: '/ground/picture',
		};

		window.location.href = window.location.origin + href_mapper[category];
	};
	return (
		<S.Container>
			<Row justify='center' style={{marginTop: 50}}>
				<Col>
					<Radio.Group
						style={{margin: '1rem'}}
						value={category}
						onChange={(e) => {
							setCategory(e.target.value);
						}}
						options={categoryOptions}
						optionType={'button'}
					/>
				</Col>
			</Row>

			<Row justify='end' style={{padding: '0px 20px'}}>
				<Col style={{padding: '0px 20px'}}>
					<AntdButton
						type={'default'}
						onClick={() => {
							setModal({...modal, create: true});
						}}
					>
						{`${category === '자유' ? '자주묻는질문' : category}게시판 글쓰기`}
					</AntdButton>
				</Col>

				<Col>
					<AntdButton onClick={goToBoard}>
						&nbsp;&nbsp;{`${category === '자유' ? '자주묻는질문' : category}게시판 이동`}&nbsp;
					</AntdButton>
				</Col>
			</Row>

			<Row justify='end' style={{padding: 20}}>
				<Col>
					<Input.Search onSearch={(e) => setSearch(e)} />
				</Col>
			</Row>

			<Table
				dataSource={post}
				pagination={{
					defaultCurrent: 1,
					total: total,
				}}
				style={{margin: '1rem'}}
				onChange={(pagination, filters, sorter, extra) => {
					setPage(pagination.current);
					setSorter(sorter);
					setStayCategory(category);
				}}
			>
				<Column
					rowSpan={2}
					title={'번호'}
					dataIndex={'no'}
					key={'no'}
					width={'5%'}
					align={'center'}
				/>
				<Column
					title={'제목'}
					align={'center'}
					dataIndex={'title'}
					key={'title'}
					width={'30%'}
					sorter={{
						multiple: 1,
					}}
					render={(text, record) => {
						return (
							<a
								onClick={() => {
									setModal({...modal, update: true});
									setId(record.id);
								}}
							>
								{text}
							</a>
						);
					}}
				/>
				<Column
					title={'작성자'}
					align={'center'}
					dataIndex={'author'}
					key={'author'}
					width={'10%'}
					responsive={['md']}
					sorter={{
						multiple: 2,
					}}
				/>
				<Column
					title={'작성일'}
					align={'center'}
					dataIndex={'created'}
					key={'created'}
					width={'20%'}
					responsive={['md']}
					sorter={{
						multiple: 3,
					}}
					render={(text) => {
						return dayjs(text)?.format('YYYY-MM-DD HH:mm');
					}}
				/>
				<Column
					title={'댓글'}
					align={'center'}
					dataIndex={'comment_count'}
					key={'comment_count'}
					width={'5%'}
					responsive={['md']}
					sorter={{
						multiple: 3,
					}}
				/>
				<Column
					title={'비밀번호'}
					align={'center'}
					dataIndex={'password'}
					key={'password'}
					width={'10%'}
					responsive={['md']}
					sorter={{
						multiple: 3,
					}}
				/>
				<Column
					title={'조회수'}
					align={'center'}
					dataIndex={'hit'}
					key={'hit'}
					width={'10%'}
					responsive={['md']}
					sorter={{
						multiple: 4,
					}}
				/>
				<Column
					title={'액션'}
					key={'action'}
					align={'center'}
					render={(_, record) => (
						<Space size='small'>
							<AntdButton
								onClick={() => {
									setModal({...modal, update: true});
									setId(record.id);
								}}
							>
								수정
							</AntdButton>
							<AntdButton
								onClick={async () => {
									await deleteBoard({id: record.id});
									setToggle(!toggle);
								}}
							>
								삭제
							</AntdButton>
						</Space>
					)}
					width={'10%'}
				/>
			</Table>

			<Modal
				open={modal.create}
				onCancel={() => {
					setModal({...modal, create: false});
					setToggle(!toggle);
				}}
				footer={[]}
			>
				<BoardForm
					category={category}
					onClose={() => {
						setModal(false);
						setToggle(!toggle);
					}}
				/>
			</Modal>
			<Modal
				open={modal.update}
				onCancel={() => {
					setModal({...modal, update: false});
					setToggle(!toggle);
				}}
				footer={[]}
			>
				{modal.update && (
					<BoardUpdateForm
						id={id}
						category={category}
						onClose={() => {
							setModal({...modal, update: false});
							setToggle(!toggle);
						}}
					/>
				)}
			</Modal>
		</S.Container>
	);
};

export default AdminBoard;
